module.exports = __webpack_public_path__ + "src/img/starttime.eb6e3cbb.svg";